import React from "react"

function FlagImageComponent({ country }) {
    let imagePath = "./assets/" + country.imageName

    return (
        <div>
            <img src={`${imagePath}`} alt='The flag to guess' />
        </div>
    )
}

export default FlagImageComponent